export default "/images/41aaea4fce00950abd20faf56386b5c1.avif";